import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { openInquiry } from "@/lib/scroll";
import { CONTACT } from "@/data/content";
import CAMPAIGN from "@/data/campaign";

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-[#1A362B]/95 backdrop-blur-xl border-t border-[#F5F2EB]/10"
          data-testid="sticky-cta-bar"
        >
          <div className="max-w-7xl mx-auto px-4 md:px-12 py-3 flex items-center justify-between gap-3">
            <div className="text-[#F5F2EB]" data-testid="sticky-price">
              <p className="font-heading text-xl md:text-2xl leading-none">
                {CAMPAIGN.pricing.price} <span className="text-xs font-body font-light text-[#F5F2EB]/60">{CAMPAIGN.batches.landNote}</span>
              </p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#F5F2EB]/60 mt-1 hidden sm:block">
                {CAMPAIGN.hero.meta[1]}
              </p>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 border border-[#F5F2EB]/30 text-[#F5F2EB] text-xs font-semibold uppercase tracking-[0.15em] px-4 md:px-5 py-3 hover:bg-[#F5F2EB]/10 transition-colors duration-300"
                data-testid="sticky-whatsapp-button"
              >
                <MessageCircle className="w-4 h-4" />
                <span className="hidden sm:inline">WhatsApp</span>
              </a>
              <button
                onClick={openInquiry}
                className="bg-primary text-primary-foreground text-xs font-semibold uppercase tracking-[0.15em] px-5 md:px-7 py-3 hover:bg-[#2E9440] transition-colors duration-300"
                data-testid="sticky-cta-button"
              >
                Request callback
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
